import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck2 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.5 7.5L7 12L14 5M2.5 7",
		stroke: "currentColor",
		fill: "none",
		strokeWidth: 3,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgCheck2);
export { ForwardRef as ReactComponent };
